import React, { useState, useEffect, useContext,useMemo } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import clientimg from '../assets/images/client.png';
import {  Row, Col } from "react-bootstrap";
import Navbar from './Navbar';
import { useLocation   } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
import Loader from '../components/Loader';
import FeedbackWidget from '../components/FeedbackWidget';
import html2pdf from 'html2pdf.js';
import { decryptString  } from '../utils/commonFunctions';
import { CONFIG} from '../config';



const Cir = () => {
  const location = useLocation();
  const fullPath = location.pathname; 
  const encryptedId = fullPath.replace("/cir/", "");    
  const [filterColumn, setFilterColumn] = useState(null);
  const [selectedValues, setSelectedValues] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({});
  const [searchText, setSearchText] = useState('');
  const [cir, setCir] = useState('BANK OF AMERICA');
  const [loading, setLoading] = useState(true); 
  const [postData, setPostData] = useState({}); 
  const [client, setClient] = useState(''); 
  const [e2eData, setE2eData] = useState(''); 
  const [tmsData, setTmsData] = useState(''); 
  const [cgData, setCgData] = useState(''); 
  const [cirCount, setCirCount] = useState({}); 
  const [cirData, setCirData] = useState([]); 
  const [similarCirData, setSimilarCirData] = useState([]); 
  const [selectedCirDetails, setSelectedCirDetails] = useState([]); 
  const [cirSummary, setCirSummary] = useState(''); 
  const [incSummary, setIncSummary] = useState(''); 
  const [error, setError] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const { userId } = useContext(UserContext); 
  const { cirContext, setCirContext } = useContext(UserContext);
  const [showFeedback, setShowFeedback] = useState(true);    
  const columns=['Team Name','CIR ID','Market / Market Unit','Incident Status','Business Impact','Incident Category','Incident Summary','Incident Resolution','Similar CIR'];
  const modalColumns=['Team Name','CIR ID','Client Name','Market / Market Unit','Incident Status','Business Impact','Incident Category','Incident Summary','Incident Resolution'];
  const [sortConfig, setSortConfig] = useState({
      col: 'Business Impact',
      direction: 'desc',
    });

  const getUniqueValues = (col) => {
    return [...new Set(cirData.map((item) => item[col]))];
  };

  const apiUrl = CONFIG.REACT_APP_BACKEND_URL+'/classifier_retrieval';
 // const apiUrl = 'https://divadevfalcon.azurewebsites.net/classifier_retrieval';
  console.log('apiurl',apiUrl);

  const impactPriority = {
  "very high": 4,
  "high": 3,
  "medium": 2,
  "low": 1,
  };
 
      useEffect(() => {
         if(userId && encryptedId){
        setLoading(true);
        fetchData(encryptedId); 
      } 
      }, [userId,encryptedId]);
  
   const fetchData = async (id) => {
      try{
      const postData=decryptString((id));      
      console.log('request json',postData);
      //postData.query_type='cir_summary';
      postData.custom_search=false; 
      setPostData(postData);
      setClient(postData.clientName);
      setE2eData(postData.e2eName);
      setTmsData(postData.tmsName);     
      await axios.post(apiUrl, postData)
      .then(async response => {
        console.log('response',response);
        const data=response.data;
        if(response?.data?.cir_counts){
        setCirCount(response.data.cir_counts);
          }
        if(response?.data?.context?.length>0 ){
           response.data.context.forEach(item => {
          for (let key in item) {
            console.log('key',key,item);
            if(key==="incidentSummary"){
              item['Incident Summary']=item["incidentSummary"];
            } else if(key==="tmsName"){
              item['Team Name']=item["tmsName"];
            } else if(key==="id"){
              item['CIR ID']=item["id"];
            } else if(key==="businessImpactId"){
              item['Business Impact']=item["businessImpactId"];
            } else if(key==="incidentStatus"){
              item['Incident Status']=item["incidentStatus"];
            } else if(key==="incidentCategoryId"){
              item['Incident Category']=item["incidentCategoryId"];
            } else if(key==="incidentResolved"){
              item['Incident Resolution']=item["incidentResolved"];
            } else if(key==="market"){
              item['Market / Market Unit']=item["market"]+' / '+item["marketUnit"];
            } 
          }
        });
        }
        setCirData(response.data.context);
        if(postData.e2eName){
          setClient(response.data.context[0].client);  
        }
        if(postData.tmsName){
           setE2eData(response.data.context[0].e2eName);
           setClient(response.data.context[0].client); 
           setCgData(response.data.context[0].clientGroupName)  
        }
      
       // setE2eData(postData.e2eName);
        setCirSummary(response.data.summary);
        if(postData.similar){
          const cirObj=response.data.context.filter(item => item.id === Number(postData.cirId));
          console.log('cirObj',cirObj);
          await openModalPopup(cirObj[0]);
        }

      }).catch(error => {
        console.error('Error posting data:', error);
        setError("Failed to fetch data.");
      });  
    } catch (err) {
      setError("Failed to fetch data.");
    } finally {
      setLoading(false);
    } 
    }
   const openModalPopup = async (cirObj) => {
      try{
        setLoading(true);
        const postData= {
            "query": cirObj.id.toString(),
            "query_type": "cir_similarINC",
            "enterprise_id": userId,
            "startdate": "",
            "enddate": "",
            "clientName": "",
            "tmsName": "",
            "e2eName": "",
            "custom_search": "False"
        }
        console.log('cirContext',cirContext);
      if (postData.query in cirContext) {
        console.log("Matched issueId!");
         setOpenModal(true);
         setSimilarCirData(cirContext[postData.query]);
         setSelectedCirDetails(cirObj); 

      } else {
      await axios.post(apiUrl, postData)
      .then(res => {
        console.log('response',res);
        setOpenModal(true);
        setIncSummary(res.data['INC summary']);
        // const data=response.data;
        if(res?.data?.['similar INC']?.length>0 ){
           res.data['similar INC'].forEach(item => {
          for (let key in item) {
            console.log('key',key,item);
            if(key==="incidentSummary"){
              item['Incident Summary']=item["incidentSummary"];
            } else if(key==="tmsName"){
              item['Team Name']=item["tmsName"];
            } else if(key==="id"){
              item['CIR ID']=item["id"];
            } else if(key==="businessImpactId"){
              item['Business Impact']=item["businessImpactId"];
            } else if(key==="incidentStatus"){
              item['Incident Status']=item["incidentStatus"];
            } else if(key==="incidentCategoryId"){
              item['Incident Category']=item["incidentCategoryId"];
            } else if(key==="market"){
              item['Market / Market Unit']=item["market"]+' / '+item["marketUnit"];
            } else if(key==="incidentResolved"){
              item['Incident Resolution']=item["incidentResolved"];
            } else if(key==="client"){
              item['Client Name']=item["client"];
            } 
          }
        });
       
        res.data['similar INC'].sort((a, b) => {
          const priorityA = String(a.businessImpactId || "").toLowerCase();
          const priorityB = String(b.businessImpactId || "").toLowerCase();

          const diff = (impactPriority[priorityB] || 0) - (impactPriority[priorityA] || 0);

          // If priorities are equal → sort by teamname
          if (diff === 0) {
            const teamA = (a.tmsName || "").toLowerCase();
            const teamB = (b.tmsName || "").toLowerCase();
            return teamA.localeCompare(teamB);
          }

          return diff;
        });


        setSimilarCirData(res.data['similar INC']);
        setSelectedCirDetails(cirObj);
        setCirContext(prev => ({
          ...prev,
          [postData.query]: res.data['similar INC']
        }));
        console.log('cirObj',cirObj);
        }
      }).catch(error => {
        console.error('Error posting data:', error);
        setError("Failed to fetch data.");
      }); 
    } 
    } catch (err) {
      setError("Failed to fetch data.");
    } finally {
      setLoading(false);
    } 
    }

  const openFilter = (col) => {
    setFilterColumn(col);
    setSearchText('');
    setSelectedValues((prev) => ({
      ...prev,
      [col]: appliedFilters[col] || getUniqueValues(col),
    }));
  };

  const handleCheckboxChange = (value) => {
    const current = selectedValues[filterColumn] || [];
    const updated = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];
    setSelectedValues((prev) => ({
      ...prev,
      [filterColumn]: updated,
    }));
  };

  const applyFilter = () => {
    setAppliedFilters((prev) => ({
      ...prev,
      [filterColumn]: selectedValues[filterColumn],
    }));
    setFilterColumn(null);
  };

  const closeFilter = () => {
    setFilterColumn(null);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value.toLowerCase());
  };

  const handleSelectAllChange = (e) => {
    const allValues = getUniqueValues(filterColumn);
    setSelectedValues((prev) => ({
      ...prev,
      [filterColumn]: e.target.checked ? allValues : [],
    }));
  };

  const filteredData = (cirData ?? []).filter((item) =>
    columns.every((col) => {
      const selected = appliedFilters[col] || [];
      return selected.length === 0 || selected.includes(item[col]);
    })
  );

  const getFilteredValues = (col) => {
    return getUniqueValues(col).filter((val) =>
      String(val).toLowerCase().includes(searchText)
    );
  };

  const isAllSelected = () => {
    const allValues = getUniqueValues(filterColumn);
    const selected = selectedValues[filterColumn] || [];
    return selected.length === allValues.length;
  };

  const getColor = (val) => {
  switch (val && val.toLowerCase()) {
    case "low":
      return "green";
    case "medium":
      return "orange";
    case "high":
      return "red";
    case "very high":
      return "red";
    default:
      return "black";
  }
};


  const toggleSort = (col) => {
    setSortConfig((prev) => {
      if (prev.col === col) {
        if (prev.direction === 'asc') return { col, direction: 'desc' };
        if (prev.direction === 'desc') return { col: null, direction: null };
      }
      return { col, direction: 'asc' };
    });
  };

const sortedData = useMemo(() => {
  const impactPriority = {
    "very high": 4,
    "high": 3,
    "medium": 2,
    "low": 1,
  };

  return [...filteredData].sort((a, b) => {
    const valA = a[sortConfig.col];
    const valB = b[sortConfig.col];

    // --- BUSINESS IMPACT sorting (case-insensitive) ---
    if (sortConfig.col.toLowerCase() === "business impact") {
      const priorityA = impactPriority[String(valA).toLowerCase()] ?? 0;
      const priorityB = impactPriority[String(valB).toLowerCase()] ?? 0;

      return sortConfig.direction === "desc"
        ? priorityB - priorityA // Very High → Low
        : priorityA - priorityB; // Low → Very High
    }

    // --- Handle type / Asset (empty check first) ---
    if (sortConfig.col.toLowerCase() === "type" || sortConfig.col.toLowerCase() === "asset") {
      const isEmptyA = !valA?.trim?.();
      const isEmptyB = !valB?.trim?.();

      if (isEmptyA && !isEmptyB) return 1;
      if (!isEmptyA && isEmptyB) return -1;
    }

    // --- Default number sorting ---
    if (typeof valA === "number" && typeof valB === "number") {
      return sortConfig.direction === "asc" ? valA - valB : valB - valA;
    }

    // --- Default string sorting (case-insensitive) ---
    let result =
      sortConfig.direction === "asc"
        ? String(valA ?? "").toLowerCase().localeCompare(String(valB ?? "").toLowerCase())
        : String(valB ?? "").toLowerCase().localeCompare(String(valA ?? "").toLowerCase());

    // --- Special rule: reasonForEarlyClosure empty last ---
    if (sortConfig.col.toLowerCase() === "reasonforearlyclosure") {
      const isEmptyA = !valA?.trim?.();
      const isEmptyB = !valB?.trim?.();
      if (isEmptyA && !isEmptyB) return 1;
      if (!isEmptyA && isEmptyB) return -1;
      return 0; // keep relative order
    }

    return result;
  });
}, [filteredData, sortConfig]);


    // const sortedData = useMemo(() => {
    //   let dataToSort = [...filteredData];
  
    //   const sorted = [...filteredData].sort((a, b) => {
    //     const valA = a[sortConfig.col];
    //     const valB = b[sortConfig.col];
    
    //     if (sortConfig.col === 'type') {
    //       const isEmptyA = !valA?.trim();
    //       const isEmptyB = !valB?.trim();
    
    //       if (isEmptyA && !isEmptyB) return 1;
    //       if (!isEmptyA && isEmptyB) return -1;
    //     }
  
    //      if (sortConfig.col === 'Asset') {
    //       const isEmptyA = !valA?.trim();
    //       const isEmptyB = !valB?.trim();
    
    //       if (isEmptyA && !isEmptyB) return 1;
    //       if (!isEmptyA && isEmptyB) return -1;
    //     }
    
    //     if (typeof valA === 'number' && typeof valB === 'number') {
    //       return sortConfig.direction === 'asc' ? valA - valB : valB - valA;
    //     }
    
    //     return sortConfig.direction === 'asc'
    //       ? String(valA).localeCompare(String(valB))
    //       : String(valB).localeCompare(String(valA));
    //   });
  
    //   return [...sorted].sort((a, b) => {
    //     const valA = a.reasonForEarlyClosure;
    //     const valB = b.reasonForEarlyClosure;
    
    //     const isEmptyA = valA === null || valA === undefined || valA.trim?.() === '';
    //     const isEmptyB = valB === null || valB === undefined || valB.trim?.() === '';
    
    //     if (isEmptyA && !isEmptyB) return 1;
    //     if (!isEmptyA && isEmptyB) return -1;
    
    //     return 0; // don't change order otherwise
    //   });
    // }, [filteredData, sortConfig]);

      const handlePdfDownload = async () => {
          setLoading(true);
          const container = document.createElement('div');
          const ids = ['about', 'clientLevelSummary','pills-contract_details-tab','pills-contract_details','pills-key_risks-tab', 'pills-key_risks'];
          const originalStyles = [];
          ids.forEach(id => {
            const element = document.getElementById(id);
            if (element) {
              const tabpanel=['pills-contract_details','pills-key_risks'];            
              if(tabpanel.includes(id)){
                console.log('inside');
              }
              if(tabpanel.includes(id) && !element.classList.contains('active')){
                 originalStyles.push(element);
                 element.classList.add('show','active');
              }
              const clone = element.cloneNode(true);
             // clone.style.pageBreakInside = 'avoid';
              const toRemoveById = ['sortDiv','diva-userguide'];
              toRemoveById.forEach(rid => {
                const el = clone.querySelector(`#${rid}`);
                if (el) el.remove();
              });
  
               
              // //  Remove elements by class
               const toRemoveByClass = clone.querySelectorAll('.bi-filter');
                toRemoveByClass.forEach(el => el.remove());
      
              clone.style.marginBottom = '20px';
              container.appendChild(clone);
            }
          });
          const newElement = document.createElement('div');
          newElement.style.marginTop = '20px';
          newElement.style.fontSize = '14px';
          newElement.style.fontWeight = 'bold';                 
          newElement.style.color = '#A100FF';                 
          newElement.style.textAlign = 'center';                 
          newElement.innerText = 'Content Generated by Gen AI, limiting accuracy in few cases. Please use at your own discretion.'; 
          container.appendChild(newElement);
              
          
          const options = {
            margin: 0.5,
            filename: 'cir'+'.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: {
              scale: 2,
              useCORS: true,
              allowTaint: true,
            },
            jsPDF: {
              unit: 'in',
              format: 'a3', // landscape format
              orientation: 'landscape'
            },pagebreak:    { mode: ['avoid-all', 'css', 'legacy'] }
          };
          originalStyles.forEach(el  => {
            el.classList.remove('show','active');
          });
          html2pdf().set(options).from(container).save();
          setLoading(false);
        };


  return (
    <>
    <div className={!(openModal) ? "container mt-4" :"container mt-4 blur-background"}>
      <Navbar />
      {/* <div className='image-container' id='image-container'>
      <img src={clientimg}  alt="diva" className="client-img" />  
      <div className='text-overlay'>{cir.toUpperCase()}</div>
      </div> */}
      <div className='projectHeader' id="projectHeader">
           <span className="projectHeaderTms"> Critical Incident Report Summary </span>
      </div>
      <br/>
      <br/>
      <br/>
    <div id="totalClient" className="mt-4 totalClient container">
     <Row className="align-items-center mb-3">
        <Col md={6} id='about'>
          <h3>About</h3>
        </Col>
        <Col md={6} className="text-end">
        <div className="btn-group export-btn" role="group">
          <button type="button" className="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            Export
          </button>
          <ul className="dropdown-menu">
            <li><a className="dropdown-item" href="#" onClick={handlePdfDownload}>PDF</a></li>
            {/* <li><a className="dropdown-item" href="#">PDF</a></li> */}
          </ul>
        </div>
        </Col>
      </Row>
      <div className="p-2 bg-light rounded" id="clientLevelSummary">
        {/* <h5 className='summaryTypeHeading'>CIR Summary</h5> */}
        <table>
  <tbody className="container mt-2">
    <tr>
      {client && (<td className="col-6 col-md-3 width10 text-start">Client:</td>)}
      {client && (<td className="col-6 col-md-3 text-start">{client}</td>)}
      {e2eData && (<td className="col-6 col-md-3 width10 text-start">END TO END Name:</td>)}
      {e2eData && (<td className="col-6 col-md-3 text-start">{e2eData}</td>)}
    </tr>
    { cgData && 
    <tr>
      <td className="col-6 col-md-3 width10 text-start">Client Group:</td>
      <td className="col-6 col-md-3 text-start">{cgData}</td>
      <td className="col-6 col-md-3 width10 text-start"></td>
      <td className="col-6 col-md-3 text-start"></td>
    </tr> }
  </tbody>
</table>
      </div>

      <ul className="nav nav-pills mb-3 displayTab" id="pills-tab" role="tablist">
        <li className="nav-item" role="presentation">
        <button className="nav-link active" id="pills-key_risks-tab" data-bs-toggle="pill" data-bs-target="#pills-key_risks" type="button" role="tab" aria-controls="pills-key_risks" aria-selected="false">Incident Details</button>
      </li>
      <li className="nav-item" role="presentation">
        <button className="nav-link " id="pills-contract_details-tab" data-bs-toggle="pill" data-bs-target="#pills-contract_details" type="button" role="tab" aria-controls="pills-contract_details" aria-selected="true">Summary</button>
      </li>
      
      </ul>
          <div className="tab-content clientNameTab" id="pills-tabContent">
      <div className="tab-pane fade" id="pills-contract_details" role="tabpanel" aria-labelledby="pills-contract_details-tab">
      <div className="container">
        <ReactMarkdown>{cirSummary}</ReactMarkdown>
          {/* <div>Projects with CIRs: 10</div>
      <div>Total CIRs: 85</div>
      <ul>
        <li>System Issues: 30</li>
        <li>Security Issues: 35</li>
        <li>Citrix Outages: 20</li>
      </ul>
      <div>🚨 ASOC Notified CIRs: 7</div>
      <div>🟡 Open CIRs: 18</div> */}
      </div>
        </div>
      <div className="tab-pane fade  show active key_risks" id="pills-key_risks" role="tabpanel" aria-labelledby="pills-key_risks-tab">
      <div className="table-wrapper" id="table-wrapper">     
      <table className="table table-bordered fs-14 smart-table">
        <thead>
          <tr rowSpan="2" className="position-relative">
            {columns.map((col) => (
              <th key={col} style={{ position: 'relative' }}>
                 <div className="d-flex align-items-center justify-content-between">                  
                  <div
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                  <span onClick={() => toggleSort(col)}>
                    {col.toUpperCase()}
                    {sortConfig.col === col && (
                      <span style={{ marginLeft: 5 }}>
                        {sortConfig.direction === 'asc' ? '▲' : '▼'}
                      </span>
                    )}
                  </span>
                 
                 { col!='Similar CIR'?<i className="bi bi-filter" style={{ width: "16px", height: "16px", cursor: "pointer" }} onClick={() => openFilter(col)}></i>:''}
                 </div>
               
                  </div>
               
                {/* Inline Filter Popup */}
                {filterColumn === col && (
                  <div
                    className="card p-2 shadow-sm border position-absolute bg-white"
                    style={{ zIndex: 1000, top: '100%', left: 0, width: '250px' }}
                  >
                    <input
                      type="text"
                      className="form-control mb-2"
                      placeholder="Search..."
                      value={searchText}
                      onChange={handleSearchChange}
                    />

                    <div className="form-check mb-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={isAllSelected()}
                        onChange={handleSelectAllChange}
                        id={`selectAll-${col}`}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`selectAll-${col}`}
                      >
                        Select All
                      </label>
                    </div>

                    <div
                      style={{
                        maxHeight: '150px',
                        overflowY: 'auto',
                        border: '1px solid #ccc',
                        padding: '5px',
                      }}
                    >
                      {getFilteredValues(col).map((value) => (
                        <div className="form-check" key={value}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={
                              selectedValues[col]?.includes(value) || false
                            }
                            onChange={() => handleCheckboxChange(value)}
                            id={`${col}-${value}`}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`${col}-${value}`}
                          >
                            {value}
                          </label>
                        </div>
                      ))}
                    </div>

                    <div className="mt-2 d-flex justify-content-between">
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={closeFilter}
                      >
                        Close
                      </button>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={applyFilter}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sortedData.length > 0 ? (
            sortedData.map((row, idx) => (
              <tr key={idx}>
                {columns.map((col) => (
                col!='Similar CIR'?<td key={col} style={col=='Business Impact' ? { color: getColor(row[col]) } : {}}>{row[col]}</td>:<td className="viewSimilar" key={col}><a className='blueColor text-decoration-underline' onClick={() => openModalPopup(row)}>View Similar</a> </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length} className="text-center">
                No results found
              </td>
            </tr>
          )}
        </tbody>
      </table>   
    </div>
    </div>
         {showFeedback && ( <FeedbackWidget moduleName="cir_pb" onSubmit={() => setShowFeedback(false)}/>)}
             <div className="footerText">Content Generated by Gen AI, limiting accuracy in few cases. Please use at your own discretion.</div>
    </div>
    </div>
    {loading && <Loader loadingtxt='Please hold on a moment'/>}   
    </div>
    {openModal && (
              <div className="modal width100 cirModal totalClient " id="totalClient" style={{ width:'100%', display: 'block', '--bs-modal-width': '95%'}}>
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Similar Incident Summary</h5>
                      <button type="button" className="btn-close" onClick={() => setOpenModal(false)}></button>
                    </div>
                    <div className="modal-body">
                       {/* <h3>Summary</h3> */}
                      {/* <div>{incSummary}</div>                     */}
                       <div className="p-2 bg-light rounded" id="clientLevelSummary">
                         <h5 className='summaryTypeHeading'>Incident Summary</h5>
                            <table>
                      <tbody className="container mt-2">
                        <tr className='mt-2'>
                          <td className="col-6 col-md-2 width10 text-start"><span className="fw-500" >Client:</span>  {selectedCirDetails.client}</td>
                          <td className="col-6 col-md-2 width10 text-start"><span className="fw-500" >END TO END Name:</span>  {selectedCirDetails.e2eName}</td>
                          <td className="col-6 col-md-2 width10 text-start"><span className="fw-500" >Team Name: </span> {selectedCirDetails.tmsName}</td>
                        </tr>
                        <tr>
                          <td className="col-6 col-md-2 width10 text-start"><span className="fw-500" >CIR ID: </span> {selectedCirDetails.id}</td>                        
                          <td className="col-6 col-md-2 width10 text-start"><span className="fw-500" >Incident Status: </span> {selectedCirDetails.incidentCategoryId}</td>
                          <td className="col-6 col-md-2 width10 text-start"><span className="fw-500" >Business Impact: </span> <span style={{ color: getColor(selectedCirDetails.businessImpactId) }}>{selectedCirDetails.businessImpactId}</span></td>
                        </tr>
                        <tr>
                          <td className="col-6 col-md-2 width10 text-start" colSpan={3}><span className="fw-500" >Incident Summary: </span> {incSummary}</td>
                         </tr>
                      </tbody>
                    </table>
                          </div>
                          <br/>                       
                       <div style={{ maxHeight: '450px', overflowY: 'auto' }}>
                        <h5 className='summaryTypeHeading'>Similar Incident</h5>
                      <table class="table table-striped fs-14 smart-table">
                      <thead style={{ position: "sticky", top: '-15px', zIndex: 5 }}><tr>
                      {modalColumns.map((col) => (
                         col!='Similar CIR'?<th key={col} style={{ position: 'relative' }}>{col}</th>:''
                      ))}
                      </tr>
                      </thead>
                      <tbody>
                          {similarCirData.length > 0 ? (
            similarCirData.map((row, idx) => (
              <tr key={idx}>
                {modalColumns.map((col) => (
                col!='Similar CIR'? <td key={col} style={col=='Business Impact' ? { color: getColor(row[col]) } : {}}>{row[col]} </td>:''
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={modalColumns.length} className="text-center">
                No results found
              </td>
            </tr>
          )}
                          
                     </tbody>
                    </table>
                      </div>
                    </div>                                      </div>
                </div>
              </div>
            )} 
    </>
  );
};

export default Cir;
